// extracted by mini-css-extract-plugin
export default {"agree":"AgreeOrder_agree__5Vxgh","summary":"AgreeOrder_summary__3aPdV","hide":"AgreeOrder_hide__K+fhg"};